/* eslint-disable */
import { motion } from "framer-motion";

/* =========================
   GLOBAL EASING SYSTEM
========================= */
const ease = [0.22, 1, 0.36, 1];

/* =========================
   PAGE TRANSITION
========================= */
export function AdminPageMotion({ children, pageKey }) {
  return (
    <motion.div
      key={pageKey}
      initial={{ opacity: 0, y: 12 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -8 }}
      transition={{
        duration: 0.45,
        ease,
      }}
      style={{ height: "100%" }}
    >
      {children}
    </motion.div>
  );
}

/* =========================
   CARD (MAIN PREMIUM FEEL)
========================= */
export function MotionCard({ children, style = {}, hover = true }) {
  return (
    <motion.div
      whileHover={
        hover
          ? {
              y: -6,
              scale: 1.015,
              boxShadow:
                "0 30px 70px rgba(17, 32, 66, 0.12), 0 10px 30px rgba(79,99,255,0.10)",
            }
          : {}
      }
      transition={{
        type: "spring",
        stiffness: 220,
        damping: 18,
      }}
      style={{
        ...style,
        transition: "box-shadow 0.25s ease",
      }}
    >
      {children}
    </motion.div>
  );
}

/* =========================
   BUTTON MOTION
========================= */
export function MotionButton({ children, style = {}, ...props }) {
  return (
    <motion.button
      whileHover={{ scale: 1.03 }}
      whileTap={{ scale: 0.97 }}
      transition={{ type: "spring", stiffness: 260, damping: 18 }}
      style={style}
      {...props}
    >
      {children}
    </motion.button>
  );
}

/* =========================
   SIDEBAR ITEM (IMPORTANT)
========================= */
export function SidebarItemMotion({
  children,
  style = {},
  isActive,
  ...props
}) {
  return (
    <motion.button
      whileHover={{
        x: 6,
        background: isActive
          ? undefined
          : "rgba(255,255,255,0.08)",
      }}
      whileTap={{ scale: 0.97 }}
      transition={{ type: "spring", stiffness: 260, damping: 18 }}
      style={{
        ...style,
        position: "relative",
      }}
      {...props}
    >
      {/* 🔥 ACTIVE GLOW BAR */}
      {isActive && (
        <motion.div
          layoutId="sidebar-active-indicator"
          style={{
            position: "absolute",
            left: -10,
            top: 8,
            bottom: 8,
            width: 4,
            borderRadius: 10,
            background:
              "linear-gradient(180deg, #ffffff, rgba(255,255,255,0.5))",
            boxShadow: "0 0 12px rgba(255,255,255,0.6)",
          }}
        />
      )}

      {children}
    </motion.button>
  );
}

/* =========================
   STAGGER SYSTEM
========================= */
export function FadeUpStagger({
  children,
  delay = 0,
  gap = 0.06,
}) {
  return (
    <>
      {Array.isArray(children) &&
        children.map((child, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0, y: 14 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{
              delay: delay + index * gap,
              duration: 0.4,
              ease,
            }}
          >
            {child}
          </motion.div>
        ))}
    </>
  );
}